import { Component, OnInit } from '@angular/core';
import moment from 'moment-timezone';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { OOVenue } from 'src/app/shared/models/oo-venue';
import { Store } from 'src/app/shared/models/store';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss'],
})
export class OnboardingComponent implements OnInit {
  confirmPassword: string;
  connectorStatus: string;
  interval;
  key: number;
  loading: boolean;
  process: string;
  onboardKey;
  ooVenue: OOVenue = new OOVenue();
  passwordMessage: string;
  revenueCenters: any[];
  step = 0;
  store: Store;
  timerRemaining: number;
  timezones: any[] = [];

  constructor(
    public app: AppService,
    private focuslink: FocuslinkService,
  ) { }

  async findKey() {
    const store = await this.getStore();
    if (!store) { return }
    await this.getOOVenue();
  }

  async getOOMenuStatus() {
    this.loading = true;
    try {
      const status = await this.focuslink.getOOMenuStatus(this.key);
      this.loading = false;
      if (status[0] && status[0] && status[0].status === 1) {
        this.step = 3
        this.loading = false;
      }
      if (status[0] && status[0].status === 2) {
        this.step = 4;
        this.loading = false;
      }
      if (!status[0]) {
        this.process = `It looks like the menu isn't ready from Focus yet. Check in at the store level.`
      }
    } catch (error) {
      this.loading = false;
      this.app.msgSvc.add({ severity: 'error', detail: 'Error getting menu status' });
    }
  }

  async getOOVenue() {
    this.process = `Checking to see if ${this.store.name} is already registered`;
    this.loading = true;
    try {
      this.ooVenue = await this.focuslink.getOOVenue(this.key);
      this.loading = false;
      this.step = 99;
      this.process = null;
    } catch (error) {
      this.loading = false;
      this.step++;
      this.process = "Please complete the form below";
      // this.ooVenue.timezone = 'America/Los_Angeles';
    }
  }

  async getStore() {
    this.process = "Looking for store info"
    this.loading = true;
    try {
      this.store = await this.focuslink.getStore(this.key);
      this.loading = false;
      this.process = null;
      return this.store;
    } catch (error) {
      this.loading = false;
      this.app.msgSvc.add({ severity: 'error', detail: 'Error finding store' });
      return;
    }
  }

  async paymentTokenExchange(params: any) {
    try {
      this.process = `Connecting to Store to Shift4`;
      await this.focuslink.paymentTokenExchange(this.key, params);
    } catch (error) {
      console.log(error);
    }
  }

  ngOnInit() {
    this.revenueCenters = [];
    for (let i = 1; i < 43; i++) {
      this.revenueCenters.push({ label: i, value: i });
    }
    this.timezones = moment.tz.zonesForCountry('US').map(tz => ({
      label: tz,
      value: tz
    }))
  }

  async onboard() {
    if (this.ooVenue.adminPassword !== this.confirmPassword) {
      this.passwordMessage = "Passwords do not match";
      return;
    }

    this.step++;
    this.process = `Connecting to FocusLink`;
    this.ooVenue.adminPassword = btoa(this.ooVenue.adminPassword);

    this.loading = true;
    try {
      await this.saveOOVenue();
      this.loading = false;
      this.process = null;
    } catch (error) {
      this.loading = true;
      this.app.msgSvc.add({ severity: 'error', detail: 'Error saving venue' });
      return;
    }

    if (this.ooVenue.ccProcessor === 1 && this.ooVenue.ccProcessorApiKey) {
      this.process = `Connecting ${this.ooVenue.name} to Shift4 Payments`;
      this.loading = true;
      try {
        await this.paymentTokenExchange({ apiKey: this.ooVenue.ccProcessorApiKey });
        this.loading = false;
        this.process = null;
      } catch (error) {
        this.loading = true;
        this.app.msgSvc.add({ severity: 'error', detail: 'Error exchanging token' });
        return;
      }
    }

    this.process = `Requesting initial Online Menu from Focus POS`;
    try {
      await this.focuslink.ooMenuLoad(this.key);
      this.loading = false;
      this.process = null;
    } catch (error) {
      this.loading = true;
      this.app.msgSvc.add({ severity: 'error', detail: 'Error loading menu' });
      return;
    }

    this.startTimer();
  }

  async saveOOVenue() {
    try {
      this.process = `Saving Store info`;
      return this.focuslink.saveOOVenue(this.key, this.ooVenue);
    } catch (error) {
      throw error;
    }
  }

  async startTimer() {
    this.timerRemaining = 30;
    const timerId = setInterval(async () => {
      if (this.timerRemaining > 0) {
        this.process = `Waiting to check menu load status ${this.timerRemaining} seconds remaining.`
        this.timerRemaining--;
      }
      else {
        clearInterval(timerId);
        await this.getOOMenuStatus();
      }
    }, 1000)
  }

}
